export async function callMiniMax(input: string, context: any, apiKey: string, signal?: AbortSignal): Promise<string> {
  // MiniMax-M2.5 is a common model for v2
  const model = context.modelOverride || context.model || 'MiniMax-M2.5';
  const cleanKey = apiKey.trim();
  // Use the global endpoint which is more reliable for international keys
  const url = `https://api.minimaxi.chat/v1/text/chatcompletion_v2`;

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${cleanKey}`,
        'Content-Type': 'application/json'
      },
      signal,
      body: JSON.stringify({
        model,
        messages: [
          { 
            role: 'system', 
            content: `You are OS Bot, a real estate CRM assistant. Personality: ${context.personality || 'professional'}.` 
          },
          { role: 'user', content: input }
        ],
        temperature: 0.2,
        max_tokens: 512
      })
    });
    
    console.log('[MinMax] Response status:', res.status);
    const responseText = await res.clone().text();
    console.log('[MinMax] Response body:', responseText);
    
    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.base_resp?.status_msg || `MiniMax API error: ${res.status}`);
    }

    const data = await res.json();
    
    // Minimax sometimes returns 200 with error in body
    if (data.base_resp && data.base_resp.status_code !== 0) {
      throw new Error(data.base_resp.status_msg || `MiniMax error code: ${data.base_resp.status_code}`);
    }

    return data.choices?.[0]?.message?.content || '';
  } catch (error: any) {
    console.error('[MiniMax Provider] Error:', error);
    throw error;
  }
}
